import React from "react";
import Framework from "@beardeddevops/react.framework";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import {Button} from "reactstrap";
import TextField from '@material-ui/core/TextField';
// import TextField from '@mui/material/node';
import {toast} from "react-toastify";
import ImportList from '../Parts/ImportList';
import ObjectOverride from "components/ObjectOverride";
import UniversalModalOverride from "components/UniversalModalOverride";
import BarcodeReader from 'react-barcode-reader';
import Tooltip from "@material-ui/core/Tooltip";
import CaliberAddModal from "./CaliberAddModal";
import ManufacturerAddModal from "./ManufacturerAddModal";
import {confirmAlert} from "react-confirm-alert";
import ProductFinishFields from "./ProductFinishFields";

const DUPLICATE_SERIAL_WARNING = 'This serial already exists on your account.';
const DUPLICATE_ACQUISITION_SERIAL_WARNING = 'The same serial number has been entered more than once on this acquisition.';

/**
 *  @property {Products_Object} state
 *  @property {object} model
 *  @property {Products_Properties} model.properties
 *  @property {Products_Is} model.is
 *  @property {Products_Has} model.has
 */
class ProductAddObject extends ObjectOverride {
	constructor(props) {
		super(props, Types.Products._name);


		this.skuLookupModel = new API.BuildClass(Types.Products._name, 'GET_SKU');
		this.duplicateSerialLookupModel = new API.BuildClass(Types.Products._name, 'GET_DUPLICATE_SERIAL');
		// noinspection JSPrimitiveTypeWrapperUsage
		this.model.properties.serial_number.required = false;

		//Set UI only fields
		this.state.range_start = "";
		this.state.range_end = "";
		this.state.showImportListModal = false;
		this.state.importListValue = '';
		this.state.importListError = '';
		this.state.myScan = '';
		//Set default values as needed
		this.state.serial_numbers = [];
		this.state.used_firearm = false;
		this.state.show_custom_caliber = false;
		this.state.show_caliber_modal = false;
		this.state.show_custom_manufacturer = false;
		this.state.show_manufacturer_modal = false;
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		if (this.state.search !== this.props.scannedCode) {
			this.setState({
				search: this.props.scannedCode
			}, this.shouldHandleScan);
		}
	}

	shouldHandleScan = async () => {
		//Don't process the code if another popup is open
		if (this.state.search && this.state.search.barcode) {
			this.setState({loading: true});

			let productModel = new API.BuildClass(Types.Products._name, API.RequestType.READ);
			// FIXME - determine how to fetch binary_id
			productModel.object.pkey = this.state.search.barcode;
			productModel.object.id = this.state.search.prefix + '-' + this.state.search.barcode

			try {
				let product = await productModel.submit(null, API.RequestType.READ);
				this.setState(product);
			} catch (e) {
			}

			this.setState({loading: false});
		}
	}

	handleProcess(event, requestOverride) {
		let valid = super.handleProcess(event, requestOverride);
		let serial_numbers = this.getActiveSerialNumbers();
		if (serial_numbers.length === 0) {
			this.setState({serial_numbers_error: 'Must include at least 1 Serial Number.'});
			valid = false;
		}
		if (!this.state.caliber && !this.state.caliber_other) {
			this.setState({caliber_other_error: 'Must have a caliber.'});
			valid = false;
		}
		if (!this.state.manufacturer && !this.state.manufacturer_other) {
			this.setState({manufacturer_other_error: 'Must have a manufacturer.'});
			valid = false;
		}
		return valid;
	};


	async handleSubmit(event, suppressToast = false) {
		if (typeof event !== 'undefined' && event !== null) {
			event.preventDefault();
		}
		this.handleProcess();
		if (this.state.type && (this.state.manufacturer || this.state.manufacturer_other) && this.state.model && (this.state.caliber || this.state.caliber_other)) {
			this.setState({serial_numbers_error: ''});
			this.state.serial_numbers = this.getActiveSerialNumbers();
			await this.submitProduct({suppressToast});
		}
	};

	/**
	 * Return TRUE to prevent handleSubmit from running afterSave(data) if already ran in the override here.
	 * @param data
	 * @param request
	 * @param suppressProcess
	 * @returns {Promise<void>}
	 */
	async afterSubmit(data, request, suppressProcess = false) {
		// console.log('in product add after submit', this);
		if (typeof this.props.afterSave !== 'undefined') {
			let products = data.serial_numbers.map((serial, i) => {
				// noinspection JSUnresolvedVariable
				return {
					...data,
					serial_number: serial,
					pkey: data.pkeys[i]
				}
			});
			this.props.afterSave(products);
		}
	};

	handleDataChange = event => {
		this.setState({[event.target.name]: event.target.value});
	};

	serialNumberUpdate = () => {
		let start = this.state.range_start.toString();
		let end = this.state.range_end.toString();

		if (start === end) return;
		let min_length = start.length < end.length ? start.length : end.length;
		let match_length = 0;
		let i;

		// If start == end throw a fit
		for (i = 0; i < min_length; i++) {
			if (start.charAt(i) === end.charAt(i)) {
				match_length++;
			} else {
				break;
			}
		}
		for (i = (match_length - 1); i >= 0; i--) {
			if (start.charAt(i).isNumeric()) {
				match_length--;
			} else {
				break;
			}
		}
		let prefix_string = start.substring(0, match_length);
		let start_number = start.substring(match_length);
		let end_number = end.substring(match_length);

		//This matches GFS 100 -> GFS 200 to GFS 100, GFS 101, GFS 102, etc. instead of GFS0100, GFS0101, etc.
		let should_pad_space = false;
		let start_string_split = start.split(' ');
		let end_string_split = end.split(' ');
		if(start_string_split.length > 1 && end_string_split.length > 1) {
			if (start_string_split[0].match(/[a-z]/i) && start_string_split[1].match(/[0-9]/i)) {
				if (end_string_split[0].match(/[a-z]/i) && end_string_split[1].match(/[0-9]/i)) {
					should_pad_space = true;
				}
			}
		}

		if (!start_number.isNumeric() || !end_number.isNumeric()) {
			toast.warn(Framework.Toast.TitledNotice("Non Matching Sequence", "Serial numbers should match up to the sequential numbers.  If you have serial numbers that do not match use the Individual Serial Numbers section for those."), {
				position: toast.POSITION.TOP_CENTER
			});
			return;
		}

		let required_length = 0;

		let original_start = start_number;
		let original_end = end_number;

		start_number = Number(start_number);
		end_number = Number(end_number);

		if (original_start.length !== start_number.length || original_end.length !== end_number.length) {
			if (original_start.length !== original_end.length) {
				toast.warn(Framework.Toast.TitledNotice("Serial Number's With Leading Zeros", "Start and End Serial Numbers must have the same total length to calculate Serial Numbers with leading Zeros."), {
					position: toast.POSITION.TOP_CENTER
				});
				return;
			}

			required_length = original_start.length;
		}

		if (start_number > end_number) {
			toast.warn(Framework.Toast.TitledNotice("Serial Number Order", "Start Serial Number can not be greater than the End Serial Number."), {
				position: toast.POSITION.TOP_CENTER
			});
			return;
		}

		let serial_numbers = [];
		for (; start_number <= end_number; start_number++) {
			let calculated_number;
			if(should_pad_space) {
				calculated_number = prefix_string + start_number.padUntil(required_length, ' ');
			}
			else {
				calculated_number = prefix_string + start_number.padUntil(required_length);
			}
			serial_numbers.push(calculated_number);
		}

		serial_numbers = [...new Set(serial_numbers)];

		this.setState({serial_numbers});
	};

	removeSerialNumber = (serialIndex) => () => {
		this.setState({serial_numbers: this.state.serial_numbers.filter((entry, index) => index !== serialIndex)});
	};

	updateSerialNumber = (event) => {
		let serials = this.state.serial_numbers;
		serials[event.target.name] = event.target.value;
		this.setState({
			serial_numbers: serials,
			serial_numbers_error: ''
		});
	};

	handleProductLookup = async () => {
		let {sku} = this.state;
		(sku.split("-").length === 3 && sku.split("-")[0] === "P") ? this.skuLookupModel.object.id = sku : this.skuLookupModel.object.sku = sku;
		let product = await this.skuLookupModel.submit(null, 'GET_SKU');
		//Need to remove the pkey and binary id so the system doesn't treat it as an update
		product.pkey = null;
		product.binary_id = null;
		this.skuLookupModel.object.id = null;
		this.skuLookupModel.object.sku = null;
		this.setState(product);

	}

	handleTextFieldOverride = (e, value) => {
		this.handleTextFieldPropertyUpdate(e, value);
		if(this.state.atfRequired.includes(e)) {
			this.state.atfModalPop = true;
		}
	}

	handleImportListClick = () => {
		let {showImportListModal} = this.state;
		this.setState({showImportListModal: !showImportListModal});
	}

	handleImportListChange = (importListValue) => {
		let {serial_numbers} = this.state;
		let lines;

		if (!importListValue.length) {
			this.setState({importListError: 'Serial number list cannot be blank.'});
			return;
		}

		lines = importListValue.split(/[,\n]/)
			.map((line) => line.trim());

		serial_numbers = serial_numbers.concat(lines);
		serial_numbers = serial_numbers.filter(function (el) {
			return el != null && el.trim() !== '';
		});

		this.setState({
			serial_numbers,
			serial_numbers_error: '',
			showImportListModal: false,
			importListValue: '',
			importListError: '',
		});
	}

	handleAddMore = async()=> {
		if (this.state.serial_numbers.length != 0) {
			this.props.setKeepOpen(true);
			this.setState({serial_numbers_error: ''});
			this.state.serial_numbers = this.getActiveSerialNumbers();
			try {
				let saved = await this.submitProduct({suppressProcess: true});
				if (saved) {
					this.setState({serial_numbers: []});
					this.updateSerialNumber();
				}
			} finally {
				this.props.setKeepOpen();
			}
		}
	}

	//Get Sku from barcode and calls Lookup search
	processScanner = async (product) => {
		this.setState({loading: true, sku: product})
		await this.handleProductLookup(product).then();
		this.setState({loading: false})
	}

	isDuplicateSerialError = (error) => {
		let message = error?.message || error?.toString?.() || '';
		return message.includes(DUPLICATE_SERIAL_WARNING);
	};

	getActiveSerialNumbers = () => this.state.serial_numbers.filter((serial) => serial != null && serial.toString().trim() !== '');

	getDuplicateAcquisitionSerialNumbers = () => {
		let serialCounts = {};
		let duplicateSerialNumbers = [];
		this.getActiveSerialNumbers().forEach((serial) => {
			let normalizedSerial = serial.toString().trim();
			serialCounts[normalizedSerial] = serialCounts[normalizedSerial] ? serialCounts[normalizedSerial] + 1 : 1;
			if (serialCounts[normalizedSerial] === 2) {
				duplicateSerialNumbers.push(normalizedSerial);
			}
		});
		return duplicateSerialNumbers;
	};

	getDuplicateProducts = async () => {
		try {
			this.duplicateSerialLookupModel.object.serial_numbers = [...new Set(this.getActiveSerialNumbers())];
			let result = await this.duplicateSerialLookupModel.submit(null, 'GET_DUPLICATE_SERIAL', true);
			return result?.duplicate_products || [];
		} catch (e) {
			return [];
		}
	};

	openDuplicateProduct = (product) => (event) => {
		event.preventDefault();
		if (!product?.pkey || !product?.binary_id) {
			return;
		}
		window.open(`/products/${product.binary_id}-${product.pkey}`, '_blank', 'noopener,noreferrer');
	};

	confirmDuplicateSerialBypass = (duplicateProducts = []) => new Promise((resolve) => {
		let completed = false;
		let finish = (shouldBypass) => {
			if (!completed) {
				completed = true;
				resolve(shouldBypass);
			}
		};
		confirmAlert({
			closeOnClickOutside: false,
			closeOnEscape: false,
			customUI: ({onClose}) => (
				<div className="react-confirm-alert">
					<div className="react-confirm-alert-body">
						<h1>Duplicate Serial Detected</h1>
						<p>One or more serial numbers already exist on this account.</p>
						{duplicateProducts.length > 0 &&
							<div style={{marginBottom: '12px'}}>
								<p style={{marginBottom: '8px'}}><strong>Duplicate serials:</strong></p>
								<div style={{maxHeight: '180px', overflowY: 'auto', paddingRight: '4px'}}>
									<ul style={{marginBottom: 0, paddingLeft: '20px'}}>
										{duplicateProducts.map((product) => (
											<li key={`${product.binary_id}-${product.pkey}`}>
												<a
													href={`/products/${product.binary_id}-${product.pkey}`}
													target="_blank"
													rel="noopener noreferrer"
													onClick={this.openDuplicateProduct(product)}
												>
													{product.serial_number}
												</a>
											</li>
										))}
									</ul>
								</div>
							</div>
						}
						<p>Click Okay to add the duplicate serial anyway.</p>
						<div className="react-confirm-alert-button-group">
							<button
								onClick={() => {
									finish(false);
									onClose();
								}}
								className={'btn btn-default'}
							>
								Cancel
							</button>
							<button
								onClick={() => {
									finish(true);
									onClose();
								}}
								className={'btn btn-success'}
							>
								Okay
							</button>
						</div>
					</div>
				</div>
			)
		});
	});

	confirmDuplicateAcquisitionSerials = (duplicateSerialNumbers = []) => new Promise((resolve) => {
		let completed = false;
		let finish = (shouldContinue) => {
			if (!completed) {
				completed = true;
				resolve(shouldContinue);
			}
		};
		confirmAlert({
			closeOnClickOutside: false,
			closeOnEscape: false,
			customUI: ({onClose}) => (
				<div className="react-confirm-alert">
					<div className="react-confirm-alert-body">
						<h1>Duplicate Serial In This Acquisition</h1>
						<p>{DUPLICATE_ACQUISITION_SERIAL_WARNING}</p>
						{duplicateSerialNumbers.length > 0 &&
							<div style={{marginBottom: '12px'}}>
								<p style={{marginBottom: '8px'}}><strong>Repeated serials:</strong></p>
								<div style={{maxHeight: '180px', overflowY: 'auto', paddingRight: '4px'}}>
									<ul style={{marginBottom: 0, paddingLeft: '20px'}}>
										{duplicateSerialNumbers.map((serialNumber) => (
											<li key={serialNumber}>{serialNumber}</li>
										))}
									</ul>
								</div>
							</div>
						}
						<p>Click Okay to add the repeated serial anyway.</p>
						<div className="react-confirm-alert-button-group">
							<button
								onClick={() => {
									finish(false);
									onClose();
								}}
								className={'btn btn-default'}
							>
								Cancel
							</button>
							<button
								onClick={() => {
									finish(true);
									onClose();
								}}
								className={'btn btn-success'}
							>
								Okay
							</button>
						</div>
					</div>
				</div>
			)
		});
	});

	submitProduct = async ({suppressToast = false, suppressProcess = false} = {}) => {
		if (!suppressProcess && this.state.loading) {
			return false;
		}

		let duplicateAcquisitionSerialNumbers = this.getDuplicateAcquisitionSerialNumbers();
		if (duplicateAcquisitionSerialNumbers.length > 0) {
			let shouldContinue = await this.confirmDuplicateAcquisitionSerials(duplicateAcquisitionSerialNumbers);
			if (!shouldContinue) {
				return false;
			}
		}

		let bypassDuplicateSerial = false;
		let retrySubmit = false;
		do {
			retrySubmit = false;
			if (!suppressProcess && this._ismounted) {
				this.toggleLoading(true);
			}

			let previousDuplicateSerial = this.state.duplicate_serial;
			this.state.duplicate_serial = bypassDuplicateSerial;

			try {
				if (!(suppressProcess || this.handleProcess(null, null))) {
					return false;
				}

				let data = await this.model.submit(this, this.update, suppressToast, suppressProcess);
				let stopSubmitting = await this.afterSubmit(data, this.update, suppressProcess);
				if (!stopSubmitting && typeof this.props.afterSave !== 'undefined') {
					this.props.afterSave(data);
				}
				return true;
			} catch (error) {
				if (!bypassDuplicateSerial && this.isDuplicateSerialError(error)) {
					if (!suppressProcess && this._ismounted) {
						this.toggleLoading(false);
					}
					let duplicateProducts = await this.getDuplicateProducts();
					let shouldBypass = await this.confirmDuplicateSerialBypass(duplicateProducts);
					if (shouldBypass) {
						bypassDuplicateSerial = true;
						retrySubmit = true;
					}
				}
				if (!retrySubmit) {
					return false;
				}
			} finally {
				this.state.duplicate_serial = previousDuplicateSerial;
				if (!suppressProcess && this._ismounted) {
					this.toggleLoading(false);
				}
			}
		} while (retrySubmit);

		return false;
	};

	handleNewCaliber = async () => {
		this.setState({show_caliber_modal: true})
	}

	handleSaveCaliber = async (name) => {
		let cModel = new API.BuildClass(Types.Calibers._name, 'PUT_CUSTOM_CALIBER')
		cModel.object.name = name;
		let result = await cModel.submit(null, 'PUT_CUSTOM_CALIBER');
		this.setState({caliber: result.caliber.pkey, calibers: result.caliber})

	}


	handleCloseCaliberModal = async () => {
		this.setState({show_caliber_modal: false})
	}


	handleNewManufacturer = async () => {
		this.setState({show_manufacturer_modal: true})
	}

	handleSaveManufacturer = async (name) => {
		let cModel = new API.BuildClass(Types.Manufacturers._name, 'PUT_CUSTOM_MANUFACTURER')
		cModel.object.name = name;
		let result = await cModel.submit(null, 'PUT_CUSTOM_MANUFACTURER');
		this.setState({manufacturer: result.manufacturer.pkey, manufacturers: result.manufacturer})
	}


	handleCloseManufacturerModal = async () => {
		this.setState({show_manufacturer_modal: false})
	}


	displaySkuAndUpcField() {
		if(this.props.rootState.account_number === 3281 || this.props.rootState.hasGunsAmericaModule) {
			return (
				<>
				<div className="form-group">
					<div className={"row"}>
						<div className={"col-md-9"}>
							<div>
								<BarcodeReader
									minLength={3}
									onScan={this.processScanner}
								/>
							</div>
							<Framework.Elements.TextField
								label={"SKU"}
								value={this.state.sku}
								error={this.state.sku_error}
								property={this.model.properties.sku}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
						<div className={"col-md-3 text-right pl-0"}>
							<Button
								size={"md"}
								color="green-meadow"
								onClick={this.handleProductLookup}>
								Lookup
							</Button>
						</div>
					</div>
				</div>
				<div className={"row"}>
					<div className={"col-md-12"}>
						<div className="form-group">
							<Framework.Elements.TextField
								label={"UPC"}
								value={this.state.upc}
								error={this.state.upc_error}
								property={this.model.properties.upc}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
					</div>
				</div>
				</>
			)
		}
		return (
			<div className="form-group">
				<div className={"row"}>
					<div className={"col-md-9"}>
						<div>
							<BarcodeReader
								minLength={3}
								onScan={this.processScanner}
							/>
						</div>
						<Framework.Elements.TextField
							label={"SKU or UPC"}
							value={this.state.sku}
							error={this.state.sku_error}
							property={this.model.properties.sku}
							update={this.handleTextFieldPropertyUpdate}
						/>
					</div>
					<div className={"col-md-3 text-right pl-0"}>
						<Button
							size={"md"}
							color="green-meadow"
							onClick={this.handleProductLookup}>
							Lookup
						</Button>
					</div>
				</div>
			</div>
		)
	}


	//Note: Doesn't need a form() function. Only ever used in a modal
	render() {
		/** @type {Products_Properties} properties */
		let properties = this.model.properties;
		/** @type {Products_Object} object */
		let object = this.state;
		let {loading} = this.state;
		let {rootState} = this.props;
		return (
			<div>
				<fieldset>
					<div className={"row"}>
						{/*#region Col 1*/}
						<div className={"col-md"}>
							{/*#region ATF Required Information*/}

							<h4 className="section-title">ATF Required Information</h4>
							<div className="form-group" data-id={'product-type'}>
								<Framework.Elements.Select
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									property={properties.type}
									value={object.type}
									error={object.type_error}
									model={Types.Products_Types._name}
									id={'name'}
									nullable={true}
									limit={null}
								/>
							</div>
							{
								((object.type === 'Rifle' || object.type === 'Rifle / Shotgun') && this.props.locations.some((location) => {
									let borderStates = ["AZ", "TX", "NV", "CA"]
									return borderStates.includes(location.state)
								})) &&
								<div style={{marginTop: '-10px', marginBottom: '1rem', textAlign: 'right'}}>
									<p style={{marginBottom: '2px', color: 'grey', fontStyle: 'italic', fontSize: '12px'}}>Semi-automatic rifle with a
										detachable magazine?</p>
									<Framework.Elements.ButtonSwitch
										property={properties.semi_auto_w_detach}
										value={object.semi_auto_w_detach}
										error={object.semi_auto_w_detach_error}
										update={this.handleTextFieldPropertyUpdate}
										labelTrue={'Yes'}
										labelFalse={'No'}
										nullable={true}
									/>
								</div>
							}
							<div className="form-group" data-id={'manufacturer'}>
								<div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
									<Button
										onClick={this.handleNewManufacturer}
										data-id={'add-event'}
										className={"select-add"}
										style={{ minWidth: "30px", height: "30px", padding: "0"}}
										size={"sm"}
										outline
										color="primary"
									>
										<i className="fa fa-plus"/>
									</Button>
									<div style={{ flexGrow: 1 }}>
										<Framework.Elements.Select
											shouldLoad={true}
											update={this.handleSelectPropertyUpdate}
											property={properties.manufacturer}
											value={object.manufacturer}
											error={object.manufacturer_error}
											object={object.manufacturers}
											nullable={true}
											default={{value: '', label: 'Other (Manual Entry)'}}
											defaultFirst={false}
										/>
									</div>
								</div>
							</div>
							{!object.manufacturer ?
								<div className="form-group">
									<Framework.Elements.TextField
										label={"Manufacturer (Manual Entry)"}
										value={object.manufacturer_other}
										error={object.manufacturer_other_error}
										property={properties.manufacturer_other}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div> : null}
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Importer / Country of Manufacture"}
									value={object.importer}
									error={object.importer_error}
									property={properties.importer}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Model"}
									value={object.model}
									error={object.model_error}
									property={properties.model}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group" data-id={'caliber'}>
								<div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
									<Button
										onClick={this.handleNewCaliber}
										data-id={'add-event'}
										className={"select-add"}
										style={{ minWidth: "30px", height: "30px", padding: "0"}}
										size={"sm"}
										outline
										color="primary"
									>
										<i className="fa fa-plus"/>
									</Button>
									<div style={{ flexGrow: 1 }}>
										<Framework.Elements.Select
											shouldLoad={true}
											update={this.handleSelectPropertyUpdate}
											property={properties.caliber}
											value={object.caliber}
											error={object.caliber_error}
											object={object.calibers}
											nullable={true}
											default={{value: '', label: 'Other (Manual Entry)'}}
											defaultFirst={false}
										/>
									</div>
								</div>
							</div>
							{!object.caliber ?
								<div className="form-group">
									<Framework.Elements.TextField
										label={"Caliber (Manual Entry)"}
										value={object.caliber_other}
										error={object.caliber_other_error}
										property={properties.caliber_other}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div> : null}
							{this.props.locationHasRIModule ?
								<div>
									<h4 className="section-title">Michigan RI-060 Required Information</h4>
									<div className={"row"}>
										<div className={"col-md-5"}>
											<div className="form-group" style={{marginTop: -5}}>
												<Framework.Elements.Checkbox
													value={object.semi_auto}
													property={properties.semi_auto}
													error={object.semi_auto}
													update={() => (this.setState({semi_auto: !this.state.semi_auto}))}
													color="primary"
													label={'Semi-Auto'}
												/>
											</div>
										</div>
										{/*</div>*/}
										<div className="col-md-7">
											<div className={"form-group"}>
												<Framework.Elements.TextField
													label={"State Overall Length"}
													value={object.state_oal}
													error={object.state_oal_error}
													property={properties.state_oal}
													update={this.handleTextFieldOverride}
												/>
											</div>
										</div>
									</div>
								</div>
								: null}
							{this.props.locationHasDR7602Module &&
								<ProductFinishFields
									value={object.finish}
									update={(finish) => this.setState({finish})}
								/>
							}
							{/*#endregion*/}
						</div>
						{/*#endregion*/}
						{/*#region Col 2*/}
						<div className={"col-md"}>
							{/*#region Product Details*/}
							<h4 className="section-title">Product Details</h4>
							<div className="form-group">
								<div className="row">
									<div className="col-6">
										<span className="input-label">New/Used Item</span>
									</div>
									<div className="col-6 text-right">
										<Framework.Elements.ButtonSwitch
											property={properties.used_firearm}
											value={object.used_firearm}
											error={object.used_firearm_error}
											update={this.handleTextFieldPropertyUpdate}
											labelTrue={'Used'}
											labelFalse={'New'}
										/>

									</div>
								</div>
							</div>
							{this.displaySkuAndUpcField()}
							<div className={"row"}>
								<div className={"col-md-6"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Barrel Length"}
											value={object.barrel_length}
											error={object.barrel_length_error}
											property={properties.barrel_length}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-md-6"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Overall Length"}
											value={object.overall_length}
											error={object.overall_length_error}
											property={properties.overall_length}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							<div className="form-group" data-id={'item_description'}>
								<Framework.Elements.TextField
									label={"Bound Book Notes"}
									value={object.item_description}
									error={object.item_description_error}
									property={properties.item_description}
									update={this.handleTextFieldPropertyUpdate}
									multiline={4}
								/>
							</div>
							<div className={"row"}>
								<div className={"col-md-4"}>
									<h4 className="section-title">Cost</h4>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Cost"}
											value={object.cost}
											error={object.cost_error}
											property={properties.cost}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								{this.props.rootState.account_number !== 880 ?
									<div className={"col-md-4 pl-0"}>
										<h4 className="section-title">Min Price</h4>
										<div className="form-group">
											<Framework.Elements.TextField
												label={"Min Price"}
												value={object.price_min}
												error={object.price_min_error}
												property={properties.price_min}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div> :
									<div className={"col-md-4"}>
										<h4 className="section-title">Appraised Value</h4>
										<div className="form-group">
											<Framework.Elements.TextField
												label={"Appraisal"}
												value={object.appraisal_value}
												error={object.appraisal_value_error}
												property={properties.appraisal_value}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								}
								<div className={"col-md-4 pl-0"}>
									<h4 className="section-title">List Price</h4>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"List Price"}
											value={object.price_list}
											error={object.price_list_error}
											property={properties.price_list}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Retail Label Notes"}
									value={object.tag_note}
									error={object.tag_note_error}
									property={properties.tag_note}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Tooltip title={"(e.g. 12 + 1)"} placement={"right-end"}>
									<Framework.Elements.TextField
										label={"Shot (Magazine Capacity)"}
										value={object.shot}
										error={object.shot_error}
										property={properties.shot}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</Tooltip>
							</div>
							{this.props.rootState.account_number === 880 &&
								<Framework.Elements.Select
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									property={properties.product_buyer}
									value={object.product_buyer}
									error={object.product_buyer_error}
									model={Types.Custom_Modules_Customs_880._name}
									requestOverride={"GET_BUYERS"}
									id={'pkey'}
									nullable={true}
									limit={null}
								/>
							}
							{/*#endregion*/}
						</div>
						{/*#endregion*/}
						{/*#region Col 3*/}
						<div className={"col-md"}>
							<div className="section-title">
								<h4 className="section-title">Sequential Serial Numbers</h4>
								<Button color="info" onClick={this.handleImportListClick}>Import List</Button>
							</div>
							<div className="form-group">
								<div className={"row"}>
									<div className={"col-md-4 pr-0"}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											name="range_start"
											label="Start Range"
											value={this.state.range_start}
											onChange={this.handleDataChange}
											size="small"
										/>
									</div>
									<div className={"col-md-4 pr-0"}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											name="range_end"
											label="End Range"
											value={this.state.range_end}
											onChange={this.handleDataChange}
											size="small"
										/>
									</div>
									<div className={"col-md-4 text-right"}>
										<Button
											data-id={'seq-sn-calculate'}
											size={"md"}
											color="green-meadow"
											onClick={this.serialNumberUpdate}>
											Calculate
										</Button>
									</div>
								</div>
							</div>
							{/*#endregion*/}
							{/*#region Individual Serial Number(s)*/}
							<div className="section-title">
								<h4 className="section-title">Individual Serial Number(s)</h4>
								<Button color="info" onClick={this.handleAddMore}>Add More</Button>
							</div>
							{this.state.serial_numbers.length <= 6 ?
								<div>
									<div className={"form-group"}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											label="Serial Number 1"
											name={'0'}
											error={this.state.serial_numbers_error !== ''}
											helperText={this.state.serial_numbers_error}
											value={this.state.serial_numbers[0] || ''}
											onChange={this.updateSerialNumber}
										/>
									</div>
									<div className={"form-group"}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											label="Serial Number 2"
											name={'1'}
											value={this.state.serial_numbers[1] || ''}
											onChange={this.updateSerialNumber}
										/>
									</div>
									<div className={"form-group"}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											label="Serial Number 3"
											name={'2'}
											value={this.state.serial_numbers[2] || ''}
											onChange={this.updateSerialNumber}
										/>
									</div>
									<div className={"form-group"}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											label="Serial Number 4"
											name={'3'}
											value={this.state.serial_numbers[3] || ''}
											onChange={this.updateSerialNumber}
										/>
									</div>
									<div className={"form-group"}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											label="Serial Number 5"
											name={'4'}
											value={this.state.serial_numbers[4] || ''}
											onChange={this.updateSerialNumber}
										/>
									</div>
									<div className={"form-group"}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											label="Serial Number 6"
											name={'5'}
											value={this.state.serial_numbers[5] || ''}
											onChange={this.updateSerialNumber}
										/>
									</div>
								</div>
								:
								<div style={{"maxHeight": "260px", "overflowY": "scroll", "paddingRight": "4px"}}>
									{this.state.serial_numbers.map((serial_number, index) =>
										<div
											key={`${index}-${serial_number}`}
											className="form-group"
											style={{
												backgroundColor: "#f9f9f9",
												paddingTop: "4px",
												paddingBottom: "4px",
												paddingLeft: "8px",
												marginBottom: "8px",
												fontSize: "14px",
												borderRadius: "3px !important",
												border: "1px solid #efefef",
											}}
										>
											{serial_number}
											<Button
												color={"danger"}
												size={"sm"}
												style={{lineHeight: "1.4", marginRight: "1px", marginTop: "-3px"}}
												className={"pull-right"}
												onClick={this.removeSerialNumber(index)}
											>
												<i className={"fa fa-times"}/>
											</Button>
										</div>
									)}
								</div>
							}
							{/*#endregion*/}
						</div>
						{/*#endregion*/}
					</div>
					<div className={"row"} style={{paddingLeft: "10px"}}>
						<p style={{lineHeight: '18px', color: '#5f5f5f', fontSize: '12px'}}>
							<strong>Tip:</strong><br/>
							You can add just one or multiple serial numbers (if you acquired multiple items of the
							same manufacturer and model).<br/>
							If you have sequential serial numbers place the first and last serial numbers in the
							Sequential Serial Numbers section.<br/>
							If you have NON sequential numbers place those in the Individual Serial Numbers section.<br/>
							For 1-6 serial numbers use the "Save" button when complete.<br/>
							For more than 6 serial numbers use the "Add More" button and the form will
							save the first 6 serial numbers so you can add more.<br/>
						</p>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					history={this.props.history}
					name={"Import List of Serial Numbers"}
					object={ImportList}
					showModal={this.state.showImportListModal}
					handleToggle={this.handleImportListClick}
					afterSave={this.handleImportListChange}
					afterSubmit={() => {}}
				/>
				{object.show_caliber_modal &&
					<CaliberAddModal
						onClose={this.handleCloseCaliberModal}
						onSave={this.handleSaveCaliber}
						/>
				}

				{object.show_manufacturer_modal &&
					<ManufacturerAddModal
						onClose={this.handleCloseManufacturerModal}
						onSave={this.handleSaveManufacturer}
					/>
				}
			</div>
		)
	}
}

export default Framework.Components.withRootState(ProductAddObject);
